import React, { useEffect, useState } from "react";
import PropertyDetailSlider from "./PropertyDetailSlider";
import PropertyCard from "../../components/PropertyCard";
import { Navigation, Autoplay, Thumbs } from "swiper/modules";
import AOS from "aos"; // Import AOS library

import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/swiper-bundle.min.css"; // Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import DeveloperStartsFrom from "../../components/DeveloperStartsFrom";
import ContactUsLeft from "../../components/ContactUsLeft";
import { defaultAmenities, PropertySaleTypes, defaultPropertyType } from "../../constants";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import NotFoundSec from "../pageNotFound/NotFoundSec";
import { slugify } from "../../helper/helperFunction";
import CustomImageComponent from "../../components/CustomImageComponent";
import { useCountryPrefix } from "../../routes/useCountryPrefix";

const PropDetailsSec = (props) => {
  const { i18n } = useTranslation();

  const countryPrefix = useCountryPrefix();

  const isRTL = i18n.language === "ar";

  const currentLang = i18n.language === "en" ? "" : i18n.language || "";

  const { data } = props;
  const amenitiesList = data?.propertyDetails?.amenities?.split(',') || [];
  const listings = data?.properties || [];

  const [isOpen, setIsOpen] = useState(false);
  const [images, setImages] = useState();


  const toggleMenu = (type = 1) => {

    setImages(data?.propertyDetails?.propertyArtifacts?.filter(artifact => artifact.artifactType === type)?.map(artifact => artifact.artifactPath) || []);
    //setIsOpen(!isOpen);
    //document.body.classList.toggle("custom-overlay");
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      const sidePanel = document.getElementById("mySidepanel");
      const toggleButton = document.querySelector(".altmenu");

      if (
        isOpen &&
        sidePanel &&
        !sidePanel.contains(event.target) &&
        toggleButton &&
        !toggleButton.contains(event.target)
      ) {
        setIsOpen(false);
        document.body.classList.remove("custom-overlay");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  useEffect(() => {
    AOS.init();
  }, []);

  return (

    <>

      <style>
        {`
       .payment-plan p {
      width: auto !important;
      }
      `}
      </style>
      <DeveloperStartsFrom companyName={data?.developerDetails?.developerName} location={data?.projectDetails?.location} priceStart={data?.developerDetails?.minPrice || 0} priceEnd={data?.developerDetails?.maxPrice || 0} developerLogo={data?.developerDetails?.thumbnailImage} phone={data?.contactDetails?.phone} whatsApp={data?.contactDetails?.whatsApp} ></DeveloperStartsFrom>

      <section className="details-slider-section">
        <div className="container">
          <div className="row">
            <div className="col-md-8 left-content">
              <PropertyDetailSlider imageData={data?.propertyDetails?.propertyArtifacts} />
              <div className="property-details-block">
                <h2 className="title">{t("property_details")}</h2>
                <div className="property-details-wrapper">
                  <div className="d-content">
                    <p>
                      <strong>{t("property_name")}</strong>
                    </p>
                    <p>
                      {/* <strong>{data?.propertyDetails?.name}</strong> */}
                      <strong>{`${data?.projectDetails?.projectName} ${data?.propertyDetails?.features?.areaSqft}${t("Metersq")} ${t(defaultPropertyType[data?.propertyDetails?.propertyType]?.label)}`}</strong>
                      {/* <strong>{`${data?.projectDetails?.projectName} ${data?.propertyDetails?.features?.areaSqft} ${t("Metersq")} ${t(defaultPropertyType[data?.propertyDetails?.propertyTypeName.toLowerCase()]?.label)}`}</strong> */}
                    </p>
                  </div>
                  <div className="d-content">
                    <p>{t("property_types")}</p>
                    <p>{t(data?.propertyDetails?.propertyTypeName.toLowerCase())}</p>
                  </div>
                  {/* <div className="d-content">
                    <p>Reference No.</p>
                    <p>
                      <strong>50758</strong>
                    </p>
                  </div> */}
                  <div className="d-content">
                    <p>{t("bedrooms")}</p>
                    <p>
                      <strong>{data?.propertyDetails?.features?.bedCount > 0 ? data?.propertyDetails?.features?.bedCount : '-'}</strong>
                    </p>
                  </div>
                  <div className="d-content">
                    <p>{t("bathrooms")}</p>
                    <p>
                      <strong>{data?.propertyDetails?.features?.bathCount > 0 ? data?.propertyDetails?.features?.bathCount : '-'}</strong>
                    </p>
                  </div>
                  <div className="d-content">
                    <p>{t("delivery_in")}</p>
                    <p>
                      <strong>{data?.propertyDetails?.delivery}</strong>
                    </p>
                  </div>
                  <div className="d-content">
                    <p>{t("payment_plan")}</p>
                    <p className="payment-plan" dangerouslySetInnerHTML={{ __html: data?.propertyDetails?.paymentPlan }} />
                  </div>
                  {data?.propertyDetails?.saleType &&

                    <div className="d-content">
                      <p>{t("sale_types")}</p>
                      <p>
                        <strong>{t(PropertySaleTypes[data?.propertyDetails?.saleType]?.label)}</strong>
                      </p>
                    </div>
                  }
                  <div className="d-content">
                    <p>{t("project")}</p>
                    <p className="color-blue">
                      <strong>{data?.projectDetails?.projectName}</strong>
                    </p>
                  </div>
                  <div className="d-content">
                    <p>{t("project_status")}</p>
                    <p>
                      <strong>{t(data?.projectDetails?.status.toLowerCase())}</strong>
                    </p>
                  </div>
                </div>
              </div>
              <div className="property-view-section">
                <h2 className="title">{t("property_view")}</h2>
                <div className="row">
                  <div className="col-md-3">
                    <a onClick={() => toggleMenu(2)} data-bs-toggle="modal" data-bs-target="#exampleModal">
                      <div className="flex-card">
                        <CustomImageComponent
                          src={"/assets/img/floor-plan.svg"}
                          alt={"Floor Plan"}
                          className={"img-fluid"}
                        />
                        <p>{t("floor_plan")}</p>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-3">
                    <a onClick={() => toggleMenu(3)} data-bs-toggle="modal" data-bs-target="#exampleModal">
                      <div className="flex-card">
                        <CustomImageComponent
                          src={"/assets/img/master-plan.svg"}
                          alt={"Master Plan"}
                          className={"img-fluid"}
                        />
                        <p>{t("master_plan")}</p>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-3">
                    <a href={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}/map?p=${slugify(data?.projectDetails?.projectName)}`} target="_blank">
                      <div className="flex-card">
                        <CustomImageComponent
                          src={"/assets/img/map.svg"}
                          alt={"View on Map"}
                          className={"img-fluid"}
                        />
                        <p>{t("view_on_map")}</p>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-3">
                    <a onClick={() => toggleMenu(1)} data-bs-toggle="modal" data-bs-target="#exampleModal">
                      <div className="flex-card">
                        <CustomImageComponent
                          src={"/assets/img/gallery.svg"}
                          alt={"Gallery"}
                          className={"img-fluid"}
                        />
                        <p>{t("gallery")}</p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="property-view-section amenities-block">
                <h2 className="title">{t("amenities")}</h2>
                <div className="row">
                  {
                    amenitiesList?.map((item, index) => (
                      <div className="col-md-4" key={index}>
                        <div className="flex-card">
                          <CustomImageComponent
                            src={defaultAmenities[item]?.image}
                            alt={defaultAmenities[item]?.label}
                            className={"img-fluid"}
                          />
                          <p>{t(defaultAmenities[item]?.label)}</p>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
              <div className="property-view-section amenities-block">
                <h2 className="title">{t("home_facts")}</h2>
                <div className="row">
                  <div className="col-md-6">
                    <div className="flex-card">
                      <CustomImageComponent
                        src={"/assets/img/family-icon.svg"}
                        alt={"Family Type"}
                        className={"img-fluid"}
                      />
                      <p>{data?.propertyDetails?.familyType}</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="flex-card">
                      <CustomImageComponent
                        src={"/assets/img/bath.svg"}
                        alt={"BathCount"}
                        className={"img-fluid"}
                      />
                      <p>{data?.propertyDetails?.features?.bathCount > 0 ? data?.propertyDetails?.features?.bathCount : ''} {t("baths")}</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="flex-card">
                      <CustomImageComponent
                        src={"/assets/img/bed.svg"}
                        alt={"BedCount"}
                        className={"img-fluid"}
                      />
                      <p>{data?.propertyDetails?.features?.bedCount > 0 ? data?.propertyDetails?.features?.bedCount : ''} {t("bedrooms")}</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="flex-card">
                      <CustomImageComponent
                        src={"/assets/img/calendar.svg"}
                        alt={"Calendar"}
                        className={"img-fluid"}
                      />
                      <p>{t("built_in")} {data?.propertyDetails?.yearBuilt}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="property-view-section amenities-block">
                <h2 className="title">{t("price_summary")}</h2>
                <div className="row">
                  <div className="col-md-6">
                    <div className="flex-card">
                      <CustomImageComponent
                        src={countryPrefix === 'eg' ? "/assets/img/egyptian-pound-icon.svg" : "/assets/img/dubai-aed-icon.svg"}
                        alt={"Dollar"}
                        className={"img-fluid"}
                      />
                      {/* <p><span style={{ fontSize: '12px' }}>{t('egp')} </span>{data?.propertyDetails?.price} {t("per_sqft")}</p> */}
                      <p><span style={{ fontSize: '12px' }}>{countryPrefix === 'eg' ? t('egp') : t('aed')} </span>{Intl.NumberFormat('EG', { currency: 'INR' }).format(data?.propertyDetails?.price)}</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="flex-card">
                      <CustomImageComponent
                        src={"/assets/img/area.svg"}
                        alt={"Area"}
                        className={"img-fluid"}
                      />
                      <p>{data?.propertyDetails?.features?.areaSqft > 0 ? data?.propertyDetails?.features?.areaSqft : ''} {t("Metersq")}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="property-view-section">
                <h2 className="title">{t("about")} {data?.projectDetails?.projectName}</h2>
                <div className="property_detail_summary" dangerouslySetInnerHTML={{ __html: data?.propertyDetails?.description }} />
              </div>

              <div className="property-view-section ul-list-box">
                <h2 className="title">
                  {t("smart_location")} {data?.projectDetails?.projectName} {t("is")}:
                </h2>
                <div className="property_detail_summary" dangerouslySetInnerHTML={{ __html: data?.propertyDetails?.nearby }} />
              </div>

              <div className="company-info-section company-info-section-bottom">
                <div className="company-info-wrapper">
                  <div className="row align-items-center">
                    <div className="col-md-12 col-lg-7">
                      <div className="left-block">
                        <p className="contact-desc">
                          {t("contact_desc")}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-5">
                      <div className="right-block">
                        <div>

                          <a className="call-btn" href={data?.contactDetails?.phone ? `tel:${data?.contactDetails?.phone}` : "#"}>

                            <CustomImageComponent src={"/assets/img/icon-call.svg"} alt={"Phone"} /> {t("call_us")}
                          </a>
                          <a className="call-btn whatsapp-btn" href={data?.contactDetails?.whatsApp ? `https://wa.me/${data?.contactDetails?.whatsApp}` : "#"} target="_blank" rel="noopener noreferrer">

                            <CustomImageComponent src={"/assets/img/icon-whatsapp.svg"} alt={"WhatsApp"} />
                            {t("whatsapp")}
                          </a>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 right-content">
              <section className="contact-section inquiry-form-right ">
                <ContactUsLeft></ContactUsLeft>
              </section>
            </div>
            <div className="col-md-12">
              <section className="property-listing-section">
                <h2 className="title">{t("new_listings")}</h2>
                <div className="listings-slider">
                  <div>
                    <Swiper
                      spaceBetween={20}
                      slidesPerView={1}
                      dir={isRTL ? "rtl" : "ltr"}
                      breakpoints={{
                        640: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                      }}
                      loop={true}
                      navigation={{
                        nextEl: ".nlnext",
                        prevEl: ".nlprev",
                      }}
                      //pagination={{ clickable: true }} // Enable pagination with clickable dots
                      modules={[Navigation]} // Include Pagination module
                    >
                      {listings.map((item, index) => (
                        <SwiperSlide key={index}>
                          <PropertyCard
                            propertyImg={item.image}
                            propertyAlt={item.title}
                            tag={item.badge}
                            delivery={item.delivery}
                            propertyId={item.propertyId}
                            propertyName={item.title}
                            propertyLocation={item.location}
                            propertyPrice={item.price}
                            propertyBed={item.features.bedCount}
                            propertyBath={item.features.bathCount}
                            propertySqft={item.features.areaSqft}
                            isUrlAppend={true}
                            projectName={item?.projectName}
                            developerName={item?.developerName}
                            propertyType={item?.propertyType}

                          ></PropertyCard>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                    <div className="arrow">

                      <a className="prev nlprev">&nbsp; </a>
                      <a className="next nlnext">&nbsp;</a>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-xl property-details-close" >
          <div className="modal-content">

            <div className="modal-body">
              <button type="button" className="property-details-close-icon" data-bs-dismiss="modal" aria-label="Close">
                <i className="fas fa-times"></i>
              </button>
              <div className="product__slider-main ">
                {images?.length > 0 ? (

                  <>

                    <Swiper
                      dir={isRTL ? "rtl" : "ltr"}
                      direction="horizontal"
                      slidesPerView={1}
                      spaceBetween={32}
                      mousewheel={true}
                      navigation={
                        images?.length > 1
                          ? {
                            nextEl: ".slider__next",
                            prevEl: ".slider__prev",
                          }
                          : false
                        //   {
                        //   nextEl: ".slider__next",
                        //   prevEl: ".slider__prev",
                        // }
                      }
                      breakpoints={{
                        0: {
                          direction: "horizontal",
                        },
                        768: {
                          direction: "horizontal",
                        },
                      }}
                      autoplay={{
                        delay: 250000,
                        disableOnInteraction: false,
                      }}
                      modules={[Autoplay, Navigation, Thumbs]}
                    >
                      {images?.map((slide, index) => {
                        return (
                          <SwiperSlide key={index}>
                            <div className="slide">
                              <CustomImageComponent src={slide} alt={slide} className={"img-responsive"} style={{ width: "101%" }} />
                            </div>
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>

                    {images?.length > 1 && (
                      <div className="arrow">

                        <a className="slider__prev prev">&nbsp;</a>
                        <a className="slider__next  next">&nbsp;</a>
                      </div>)}
                  </>
                ) : (<NotFoundSec title={t("opps")} desc={t("image_not_found")} img={"/assets/img/not-found.svg"} />
                )}

              </div>
            </div>

          </div>
        </div>
      </div>


    </>
  );
};

export default PropDetailsSec;
